import { Observable } from 'rxjs';
import { CollaboratorRepository } from '../domain/collaborator/repository';
import { Collaborator, CollaboratorCreateDTO, CollaboratorUpdateDTO } from '../domain/collaborator/entity';
import HttpClient from '../utils/http-client';

export class CollaboratorRepositoryImplementation extends CollaboratorRepository {
    list(uid: string, cid: string | null): Observable<Collaborator[]> {
        const httpClient = new HttpClient(uid, cid);
        return httpClient.get<Collaborator[]>(`/collaborators`);
    }

    create(uid: string, cid: string | null, data: CollaboratorCreateDTO): Observable<Collaborator> {
        const httpClient = new HttpClient(uid, cid);
        return httpClient.post<Collaborator>(`/collaborators`, data);
    }

    update(uid: string, cid: string | null, id: number, data: CollaboratorUpdateDTO): Observable<Collaborator> {
        const httpClient = new HttpClient(uid, cid);
        return httpClient.put<Collaborator>(`/collaborators/${id}`, data);
    }

    delete(uid: string, cid: string | null, id: number): Observable<void> {
        const httpClient = new HttpClient(uid, cid);
        return httpClient.delete<void>(`/collaborators/${id}`);
    }
}
